import { ENTER, COMMA } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Store } from "@ngrx/store";
import { WarehouseLayoutNodeHdrService, ApiVisa } from "blg-akaun-ts-lib";
import { PermissionStates } from "../../modules/permission/permission-controller/root";
import { SearchStates } from "../../modules/search/search-controller/states";
import { Observable, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { SubSink } from "subsink2";
import { Pagination} from "blg-akaun-ts-lib";
import { AppConfig } from "../../visa";

@Component({
  selector: "app-advanced-search-wms-layout-node-dropdown",
  templateUrl: "./advanced-search-wms-layout-node-dropdown.component.html",
  styleUrls: ["./advanced-search-wms-layout-node-dropdown.component.css"],
})
export class WmsLayoutNodeAdvancedSearchDropdownComponent implements OnInit {
  @Input() layoutNodeControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;


  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredWmsLayoutNodes$: Observable<any[]>;
  layoutNodes: any[] = [];
  allLayoutNodes: any[] = [];
  toppingsControl = new FormControl([]);
  apiVisa: ApiVisa = AppConfig.apiVisa;

  @ViewChild("layoutNodeInput") layoutNodeInput: ElementRef<HTMLInputElement>;
  companyTargets: string[] = [];

  constructor(
    private layoutNodeService: WarehouseLayoutNodeHdrService,
    private readonly store: Store<SearchStates>,
    private readonly permissionStore: Store<PermissionStates>
  ) {}

  ngOnInit(): void {
    let pagination = new Pagination();
      pagination.conditionalCriteria = [
        { columnName: "order", operator: "=", value: "DESC" },
        { columnName: "orderBy", operator: "=", value: "updated_date"},
      ]
    this.subs.sink = this.layoutNodeService.getByCriteria(pagination, this.apiVisa).subscribe((wmsResponse: any) => {
      const wmsListing = wmsResponse.data.map((data, index) => ({
        name: data.bl_wms_warehouse_layout_node_hdr.name,
        guid: data.bl_wms_warehouse_layout_node_hdr.guid,
        code: data.bl_wms_warehouse_layout_node_hdr.code,
      }));
      this.allLayoutNodes = wmsListing;
      this.filteredWmsLayoutNodes$ = of(this.allLayoutNodes)
      // console.log(this.allWarehouses)
    });
    this.layoutNodeControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterWmsContainers(data));
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    if (value) {
      this.layoutNodes.push(value);
    }
    event.input.value = "";
    this.layoutNodeControl.setValue(null);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_NodeField({
        nodes: this.layoutNodes,
      })
    );
  }

  remove(layoutNode: any): void {
    const i = this.layoutNodes.findIndex(
      (value) => value.guid === layoutNode.guid
    );
    this.layoutNodes[i].selected = false
    this.layoutNodes.splice(i, 1);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_NodeField({
        nodes: this.layoutNodes,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.layoutNodes.push(event.option.value);
    this.layoutNodeInput.nativeElement.value = "";
    this.layoutNodeControl.setValue(null);
  }

  filterWmsContainers(search: string)  {
    const searchResults = this.searchWmsContainers(search);
    this.filteredWmsLayoutNodes$ = of(searchResults);
  }


  searchWmsContainers(searchTerm: string): any[] {
    if (typeof searchTerm === 'string') { // Check if searchTerm is a string
      const lowerSearchTerm = searchTerm.toLowerCase();
      let output = [];
      this.allLayoutNodes.forEach((container) => {
        if (container.name.toLowerCase().includes(lowerSearchTerm) || container.code.toLowerCase().includes(lowerSearchTerm)) {
          output.push(container);
        }
      });
      console.log("output -->", output);
      return output;
    } else {
      // Handle the case where searchTerm is not a string, maybe return an empty array or throw an error
      return [];
    }
  }
  


  optionClicked(event: Event, layoutNode: any) {
    event.stopPropagation();
    this.toggleSelection(layoutNode);
  }

  toggleSelection(layoutNode: any) {
    console.log(layoutNode);
    layoutNode.selected = !layoutNode.selected;
    this.layoutNodeInput.nativeElement.value = "";
    if (layoutNode.selected) {
      this.layoutNodes.push(layoutNode);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_NodeField({
          nodes: this.layoutNodes,
        })
      );
    } else {
      const i = this.layoutNodes.findIndex(
        (value) => value.guid === layoutNode.guid
      );
      this.layoutNodes.splice(i, 1);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_NodeField({
          nodes: this.layoutNodes,
        })
      );
    }
  }

  onReset() {
    this.layoutNodes = [];
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_NodeField({
        nodes: [],
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
